import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useMemo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@emotion/react';
import { Paper } from 'components/UI';
import { getExpectedPrincipalByWeek } from 'services';
import { showApiError } from 'utils';
import EChart from '../shared/EChart';
import { jsx as ___EmotionJSX } from "@emotion/react";

var ExpectedPrincipalChart = function ExpectedPrincipalChart(_ref) {
  var _ref$currency = _ref.currency,
      currency = _ref$currency === void 0 ? 'EUR' : _ref$currency;
  var theme = useTheme();

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  useEffect(function () {
    getExpectedPrincipalByWeek({
      number_of_weeks: 8
    }).then(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          res = _ref3[0],
          err = _ref3[1];

      if (err) return showApiError(err);
      setData(res);
    });
  }, []);
  var option = useMemo(function () {
    if (!(data !== null && data !== void 0 && data.weeks)) return null;
    var weeks = Object.keys(data.weeks);
    var values = Object.values(data.weeks).map(function (v) {
      return Number(v);
    });
    var labels = weeks.map(function (_, i) {
      return "\u0421\u0435\u0434\u043C. ".concat(i + 1);
    });
    return {
      tooltip: {
        trigger: 'axis',
        formatter: function formatter(params) {
          var val = params[0];
          return "".concat(val.name, "<br/>\u0413\u043B\u0430\u0432\u043D\u0438\u0446\u0430: ").concat(Number(val.value).toFixed(2), " ").concat(currency);
        }
      },
      grid: {
        left: 10,
        right: 20,
        top: 20,
        bottom: 30,
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: labels,
        axisLabel: {
          color: theme.gray400,
          fontSize: 11
        },
        axisLine: {
          lineStyle: {
            color: theme.gray200
          }
        },
        axisTick: {
          show: false
        }
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          color: theme.gray400,
          fontSize: 11
        },
        splitLine: {
          lineStyle: {
            color: theme.gray100
          }
        }
      },
      series: [{
        type: 'bar',
        data: values,
        barWidth: 24,
        itemStyle: {
          color: theme.primary
        },
        emphasis: {
          itemStyle: {
            color: theme.primaryDark || theme.primary
          }
        }
      }]
    };
  }, [data, theme, currency]);
  return ___EmotionJSX(Paper, {
    header: "\u041E\u0447\u0430\u043A\u0432\u0430\u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0438\u0446\u0430 \u043F\u043E \u0441\u0435\u0434\u043C\u0438\u0446\u0438",
    noPadding: true,
    padding: "1em"
  }, ___EmotionJSX(EChart, {
    option: option,
    height: 280
  }));
};

ExpectedPrincipalChart.propTypes = {
  currency: PropTypes.string
};
export default ExpectedPrincipalChart;